export interface IPhoneFax {
  countryCode: string;
  phoneNumber: string;
}
